import classNames from "classnames";
import { CardSeparator } from "@/shared/Components/CardSeparator";
import type { FC } from "react";
import type { Dayjs } from "dayjs";
import type { AnniversaryEvent } from "@/services/api";
import styles from "./styles.module.scss";
import { CalendarEventCard } from "./components";

type CalendarEventListMobileProps = {
  date: Dayjs;
  events: AnniversaryEvent[];
};

export const CalendarAnniversaryListMobile: FC<CalendarEventListMobileProps> = ({
  events,
  date,
}) => {
  return (
    <ul className={classNames(styles["todo-list"], styles["anniversary-list"])}>
      {events.map((event) => {
        const id = event.personId;
        return (
          <CalendarEventCard
            anniversaryRecord={event}
            key={id}
            type={event.type}
            id={id}
            currentDate={date}
          />
        );
      })}
      <CardSeparator className={styles["anniversary-separator"]} />
    </ul>
  );
};
